import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Tabs, Tooltip } from 'antd';
import {
  DoubleRightOutlined,
  HistoryOutlined,
} from '@ant-design/icons';
import ActivityHistory from 'components/ActivityHistory/ActivityHistory';
import './ProductHistoryPanel.less';

const { TabPane } = Tabs;

const STORAGE_KEY = 'matrix.productEditor.historyPanelCollapsed';

const readCollapsed = () => {
  try {
    return localStorage.getItem(STORAGE_KEY) === '1';
  } catch (err) {
    return false;
  }
};

const writeCollapsed = (collapsed) => {
  try {
    localStorage.setItem(STORAGE_KEY, collapsed ? '1' : '0');
  } catch (err) {
    // ignore quota / private mode
  }
};

const ProductHistoryPanel = ({ productId, skuId, skuLabel }) => {
  const [collapsed, setCollapsed] = useState(readCollapsed);
  const [scope, setScope] = useState(skuId ? 'sku' : 'product');

  useEffect(() => {
    setScope(skuId ? 'sku' : 'product');
  }, [skuId]);

  const toggleCollapsed = () => {
    setCollapsed((current) => {
      const next = !current;
      writeCollapsed(next);
      return next;
    });
  };

  if (collapsed) {
    return (
      <aside className="product-history-panel product-history-panel--collapsed">
        <Tooltip title="Show history" placement="left">
          <Button
            type="text"
            icon={<HistoryOutlined />}
            onClick={toggleCollapsed}
            aria-label="Show history"
          />
        </Tooltip>
      </aside>
    );
  }

  return (
    <aside className="product-history-panel">
      <div className="product-history-panel-header">
        <span className="product-history-panel-title">
          <HistoryOutlined />
          History
        </span>
        <Tooltip title="Hide history" placement="left">
          <Button
            type="text"
            size="small"
            icon={<DoubleRightOutlined />}
            onClick={toggleCollapsed}
            aria-label="Hide history"
          />
        </Tooltip>
      </div>
      <Tabs
        size="small"
        activeKey={scope}
        onChange={setScope}
        className="product-history-panel-tabs"
      >
        <TabPane tab="Beer" key="product">
          <ActivityHistory
            context="product"
            productId={productId}
            includeSkus
            compact
          />
        </TabPane>
        <TabPane tab={skuLabel || 'SKU'} key="sku" disabled={!skuId}>
          {skuId ? (
            <ActivityHistory
              context="product_sku"
              productId={productId}
              instanceId={skuId}
              compact
            />
          ) : null}
        </TabPane>
      </Tabs>
    </aside>
  );
};

ProductHistoryPanel.propTypes = {
  productId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  skuId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  skuLabel: PropTypes.string,
};

ProductHistoryPanel.defaultProps = {
  skuId: null,
  skuLabel: null,
};

export default ProductHistoryPanel;
